<h1>Your product integrated with Gen AI tools using RAG and Model Context Protocol</h1>
<br>This app is intended to demonstrate integration with <b>ChatGpt, Claude, Copilot, Gemini, Le Chat, OpenWebUI</b>(privately/publicly hosted, that uses private/public LLMs endpoints) and other Gen AI tools. 
<br>Utilizing RAG capabilities, OAuth security and many MCP(Model Context Protocol) functions. 
<br>By implementing Model Context Protocol you provide users the option to use your service using Gen AI tools of their choice.
<br>More and more people are using Gen AI tools to help them with their daily tasks and having your app integrated with those will give you a competitive advantage!
<br>Since you are not using LLM models directly your costs are not affected!

<h2>The demo app</h2>
<br>The app is a simple todo app. 
<br>You can manage your todos with it. 
<br><b>Your todos are accessible only to your account.</b> 
<br>You can authorize your agent to access your todos on your behalf
<br>When your todos are changed, they are automatically updated in all instances of the app. 
<br>This is especially handy when you observe an AI Agent working on your todos.
<br>You can try <a routerLink="/app/todo">managing your todos here</a>. 
<br>You can login with any Microsoft or Google account

<h2>Managing todos with help of an AI Agent</h2>
<br>The interesting part is to connect an AI Agent to the app, so that it can manage your todos securely.
<br>In the tabs above you can find links with information on how to connect the app with various AI Agents
<ol>
  <li><a routerLink="/claude">Claude</a>
  <li><a routerLink="/chatgpt">Chat GPT</a>
  <li><a routerLink="/copilot-vs-code">Copilot VS Code</a> (VS Code Copilot supports ALL MCP Client features, try this one if you can)
  <li><a href="https://help.mistral.ai/en/articles/393572-configuring-a-custom-connector" rel="noopener">mistral.ai`s Le Chat</a>
  <li>Gemini CLI (gemini mcp add --transport http todoapp {{ url }}/mcp)
  <li><a href="https://github.com/openai/codex/blob/main/docs/config.md#streamable-http" rel="noopener">Codex CLI</a>
  <li><a routerLink="/copilot-studio">Copilot Studio/Copilot M365</a>
  <li>And many more Agents supporting MCP (<a href="https://modelcontextprotocol.io/clients" rel="noopener">check this page for more clients</a>)
</ol>   

<h2>More technical details</h2>
<br>This app implementing <a href="https://modelcontextprotocol.io" rel="noopener">Model Context Protocol</a>. 
<br>Any AI Agent supporting MCP can connect to this app and manage users todos on their behalf, if authorized by the User.
<br>It implements an MCP server that exposes tools to Agents in secure ways. And allows them to manage your todos on your behalf.
<br>The implementation supports following MCP features:
<ul>
  <li>OAuth2 Authorization Code Flow with PKCE for authorizing Agents to access your todos on your behalf
  <li>Dynamic Client Registration to allow Agents to register as MCP clients
  <li><a href="https://modelcontextprotocol.io/docs/learn/server-concepts#tools" rel="noopener">Tools</a>
  <li><a href="https://modelcontextprotocol.io/docs/learn/server-concepts#prompts" rel="noopener">Prompts</a>    
  <li><a href="https://modelcontextprotocol.io/docs/learn/server-concepts#resources" rel="noopener">Resources</a>
  <li><a href="https://modelcontextprotocol.io/docs/learn/client-concepts#sampling" rel="noopener">Sampling</a>
  <li><a href="https://modelcontextprotocol.io/docs/learn/client-concepts#elicitation" rel="noopener">Elicitation</a>
</ul>
<br>You can read more about authorization in the <a href="https://modelcontextprotocol.io/specification/2025-06-18/basic/authorization" rel="noopener">specification</a>.
<br>The following components are included in OAuth2 implementation:
<ul>
  <li>MCP server is exposed as <a rel="noopener" href="https://github.com/modelcontextprotocol/modelcontextprotocol/issues/205">OAuth resource</a>.
  <li>www-authenticate header on un-authenticated requests with reference to <a href="/.well-known/oauth-protected-resource">oauth protected resource</a>
  <li><a href="/.well-known/oauth-authorization-server">Authorization Server</a> metadata endpoint
</ul>
<video controls preload="none" poster="/claude-poster.jpg">
  <source src="https://apps1storage.blob.core.windows.net/todo-videos/Claude.mp4" type="video/mp4">
  Your browser does not support the video tag.
</video>